/**
 * Devuelve la descripción del estado de una certificación.
 * @param {number} certification_status - Código del estado.
 * @returns {string} - Descripción del estado.
 */
export const getCertificationStatus = (certification_status) => {
    switch (certification_status) {
        case 0: return "PENDIENTE";
        case 1: return "EN PROCESO";
        case 2: return "TERMINADO";
        case 3: return "EVALUADO";
        case 4: return "PENALIZADO";
        case 5: return "ERROR";
        case 6: return "FINALIZADO";
        default: return "Desconocido";
    }
};

/**
 * Retorna el nombre del catálogo basado en su ID.
 * @param {number} catalog_id - ID del catálogo.
 * @returns {string} - Nombre del catálogo.
 */
export const getCatalog = (catalog_id) => {
    switch (catalog_id) {
        case 1: return "EPSt";
        case 2: return "EMeT";
        case 3: return "";
        default: return "Desconocido";
    }
};

/**
 * Devuelve el tipo de certificación en texto.
 * @param {number} certification_type - Tipo de certificación.
 * @returns {string} - Nombre del tipo.
 */
export const getCertificationType = (certification_type) => {
    switch (certification_type) {
        case 1: return "Certificación";
        case 2: return "Diagnostico";
        case 3: return "Prueba";
        default: return "Desconocido";
    }
};

/**
 * Devuelve el tipo de candidato (Kids o Adults).
 * @param {number} candidate_type - Código del tipo.
 * @returns {string} - Descripción del tipo.
 */
export const getCandidateType = (candidate_type) => {
    switch (candidate_type) {
        case 1: return "Young Learners";
        case 2: return "Adults";
        case 3: return "Junior";
        default: return "Desconocido";
    }
};

/**
 * Devuelve la categoría general del candidato (Young/Junior o Adults).
 * @param {number} candidate_type - Código del tipo de candidato.
 * @returns {string} - Categoría general.
 */
export const getCandidateGroupLabel = (candidate_type) => {
    switch (candidate_type) {
        case 1:
        case 3:
            return "Young / Junior";
        case 2:
            return "Adults";
        default:
            return "Desconocido";
    }
};

/**
 * Devuelve el nivel de EPSt según su ID.
 * @param {number} level_epst - ID del nivel.
 * @returns {string} - Nivel de inglés.
 */
export const getLevelEpst = (level_epst) => {
    switch (level_epst) {
        case 1: return "Pre A1";
        case 2: return "A1";
        case 3: return "A2";
        case 4: return "B1";
        case 5: return "B2";
        case 6: return "C1";
        case 7: return "C2";
        default: return "Desconocido";
    }
};

/**
 * Devuelve la descripción de una sección de EMeT.
 * @param {number} section_id - ID de la sección.
 * @returns {string} - Descripción de la sección.
 */
export const getSectionEMET = (section_id) => {
    switch (parseInt(section_id)) {
        case 1: return "Language Proficiency and its use";
        case 2: return "Metodologí Education Methodologies for English Language Teaching";
        case 3: return "Types of Learners and Lesson planning, resources, and evaluation";
        case 4: return "Digital Area in English Language Teaching";
        default: return "Desconocido";
    }
};

/**
 * Devuelve la descripción de una sección de EPSt.
 * @param {number} section_id - ID de la sección.
 * @returns {string} - Descripción de la sección.
 */
export const getSectionEPSt = (section_id) => {
    switch (parseInt(section_id)) {
        case 1: return "Evaluates grammar rules, sentence structure, and correct usage.";
        case 2: return "Assesses written communication, coherence, and grammar accuracy.";
        case 3: return "Tests comprehension of texts, main ideas, and inference skills.";
        case 4: return "Measures understanding of spoken English in various contexts.";
        case 5: return "Evaluates pronunciation, fluency, and verbal coherence.";
        default: return "Desconocido";
    }
};

// Configuración para badges de estado
const contactBadges = [
    { content: 'Inactivo', type: 'secondary' },
    { content: 'Activo', type: 'success' },
    { content: 'Expirado', type: 'danger' },
    { content: 'En Proceso', type: 'info' },
    { content: 'Terminado', type: 'success' },
    { content: 'Pendiente', type: 'warning' },
    { content: 'N/A', type: '' }
];

/**
 * Devuelve el badge (contenido y tipo) correspondiente a un estado.
 * @param {number} status - Código del estado.
 * @returns {{content: string, type: string}} - Objeto con contenido y estilo.
 */
export const getStatusBadge = (status) => {
    switch (status) {
        case 0: return contactBadges[0]; // Inactivo
        case 1: return contactBadges[1]; // Activo
        case 2: return contactBadges[2]; // Expirado
        case 3: return contactBadges[3]; // En Proceso
        case 4: return contactBadges[4]; // Terminado
        case 5: return contactBadges[5]; // Pendiente
        default: return contactBadges[6]; // N/A
    }
};

/**
 * Obtiene el nombre del rol correspondiente a un ID.
 *
 * @param {number} roleId - ID numérico del rol.
 * @returns {string} Nombre del rol correspondiente, o "unknown" si no coincide.
 */
export function getRoleNameFromId(roleId) {
	const roleMapping = {
		1: "master",
		2: "Administrador",
		3: "Examinador",
		4: "Candidato"
	};

	return roleMapping[roleId] || "unknown";
}